<template>
  <b-modal
    :id="id"
    hide-footer
    hide-header
    centered
    no-close-on-esc
    no-close-on-backdrop
    @hidden="resetForm"
  >
    <b-row class="justify-content-end px-2 pt-2">
      <b-img
        src="https://storage.googleapis.com/komerce/assets/icons/close-circle.svg"
        class="cursor-pointer"
        @click="$bvModal.hide(id)"
      />
    </b-row>

    <div class="flex flex-col gap-4 px-2 pb-2">
      <div class="text-center text-black text-xl font-semibold">
        Download Mutasi Top Up
      </div>
      <ValidationObserver v-slot="{ invalid }">
        <div class="flex flex-col gap-1">
          <!-- Platform -->
          <BFormGroup class="w-full">
            <template #label>
              <div class="text-md text-black">
                <span>Platform</span>
                <span class="text-danger">*</span>
              </div>
            </template>
            <ValidationProvider
              v-slot="{ errors }"
              name="Platform"
              :rules="{ required: true }"
            >
              <VSelect
                v-model="form.platform"
                :options="platforms"
                placeholder="Pilih platform"
              >
                <template #option="{ label, value }">
                  <div class="flex items-center gap-2">
                    <img
                      v-if="value"
                      :src="`https://storage.googleapis.com/komerce/komads-meta/${value}.svg`"
                      :alt="`${label}-icon`"
                      class="w-5 h-5 object-contain"
                    >
                    <span>{{ label }}</span>
                  </div>
                </template>
              </VSelect>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
          <!-- Status Transaksi -->
          <BFormGroup class="w-full">
            <template #label>
              <div class="text-md text-black">
                <span>Status Transaksi</span>
                <span class="text-danger">*</span>
              </div>
            </template>
            <ValidationProvider
              v-slot="{ errors }"
              name="Status Transaksi"
              :rules="{ required: true }"
            >
              <VSelect
                v-model="form.transaction_status"
                :options="transaction_statuses"
                placeholder="Pilih status transaksi"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
          <!-- Rentang Waktu -->
          <BFormGroup class="w-full">
            <template #label>
              <div class="text-md text-black">
                <span>Rentang Waktu</span>
                <span class="text-danger">*</span>
              </div>
            </template>
            <ValidationProvider
              v-slot="{ errors }"
              name="Rentang Waktu"
              :rules="{ required: true, maxDateRange: 30 }"
            >
              <DateRangePicker
                ref="picker"
                v-model="form.range_date"
                class="w-100"
                :locale-data="datePickerConfig.locale"
                :ranges="datePickerConfig.ranges"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
        </div>
        <BButton
          block
          :variant="invalid || isLoading ? 'secondary' : 'primary'"
          :disabled="invalid || isLoading"
          size="md"
          class="w-full"
          @click="onSubmit"
        >
          <BSpinner
            v-if="isLoading"
            small
          />
          Download
        </BButton>
      </ValidationObserver>
    </div>
  </b-modal>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import VSelect from 'vue-select'
import { today, lastDateFromToday, formatYmd } from '@/store/helpers'
import DateRangePicker from 'vue2-daterange-picker'
import { newAxiosIns } from '@/libs/axios'
import { downloadFileFromBlob } from '@/libs/downloadFile'
import { maxDateRange } from '@/@core/utils/validations/validations'
import { modalDownloadTopupMutationDatepickerConfig } from '../config'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    VSelect,
    DateRangePicker,
  },
  props: {
    id: {
      type: String,
      default: 'modal-download-topup-mutation',
    },
  },
  data() {
    return {
      maxDateRange,
      form: {
        platform: '',
        transaction_status: '',
        range_date: {
          startDate: lastDateFromToday(30),
          endDate: today,
        },
      },
      platforms: [
        { value: '', label: 'Semua Platform' },
        { value: 'meta', label: 'Meta' },
        { value: 'google', label: 'Google' },
        { value: 'tiktok', label: 'Tiktok' },
      ],
      transaction_statuses: [
        { value: '', label: 'Semua' },
        { value: 'process', label: 'Diproses' },
        { value: 'success', label: 'Selesai' },
      ],
      datePickerConfig: modalDownloadTopupMutationDatepickerConfig,
      isLoading: false,
    }
  },
  methods: {
    /**
     * Handle submit form
     */
    async onSubmit() {
      try {
        this.isLoading = true
        const formatedStartDate = formatYmd(this.form.range_date.startDate)
        const formatedEndDate = formatYmd(this.form.range_date.endDate)
        const response = await newAxiosIns.get(
          '/komads/api/v1/whitelist_accounts/transactions/export',
          {
            params: {
              platform_name: this.form.platform.value,
              transaction_status: this.form.transaction_status.value,
              start_date: formatedStartDate,
              end_date: formatedEndDate,
            },
            responseType: 'blob',
            headers: {
              Accept: 'application/vnd.ms-excel',
            },
          },
        )

        const filename = `mutasi_topup_${this.form.platform.value || 'semua-platform'}_${formatedStartDate}-${formatedEndDate}.xlsx`
        downloadFileFromBlob(
          response.data,
          filename,
        )
        this.$toast_success({
          message: 'Download mutasi top up berhasil!',
        })
      } catch {
        this.$toast_error({
          message: 'Download mutasi top up gagal!',
        })
      } finally {
        this.isLoading = false
        this.$bvModal.hide(this.id)
      }
    },
    /**
     * Reset form to default
     */
    resetForm() {
      this.form = {
        platform: '',
        transaction_status: '',
        range_date: {
          startDate: lastDateFromToday(30),
          endDate: today,
        },
      }
    },
  },
}
</script>

<style scoped>
.text-black {
  color: #333333;
}
</style>
